import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import React, { useEffect } from "react";
// import img1 from '../../src/images/cards/card1.png';
// import img4 from '../../src/images/homepage/cards/four.png';
// import img3 from '../../src/images/homepage/cards/three.png';
// import img2 from '../../src/images/homepage/cards/two.png';

// const cardData = [
//   {
//     id: 1,
//     title: "EXPERT PROFESSIONALS",
//     description: "Choosing our expert professionals for your car inspection ensures peace of mind with reliable, thorough, and accurate assessments. Our experienced team is trained to identify potential issues early, helping you make informed decisions about your vehicle. With a focus on safety, transparency, and quality, we provide detailed reports that give you the confidence you need, whether buying, selling, or maintaining your car. Trust our expertise to keep your vehicle in top condition.",
//     img: img1
//   },
//   {
//     id: 2,
//     title: "STATE OF ART TOOLS",
//     description: "Choose our state-of-the-art tools for car inspections to experience the highest level of precision and accuracy. Equipped with the latest technology, our platform ensures detailed diagnostics, helping us identify even the smallest issues that may go unnoticed with traditional methods. With cutting-edge equipment, we provide reliable, in-depth reports that give you the confidence to make well-informed decisions about your vehicle’s condition. Trust our advanced tools for unmatched quality and performance in every inspection.",
//     img: img2
//   },
//   {
//     id: 3,
//     title: "COMPREHENSIVE INSPECTION",
//     description: "Put your confidence in our pre-delivery inspection services for a thorough, unbiased assessment that ensures your vehicle meets the highest standards of safety and quality. With expert technicians and advanced tools, we guarantee a comprehensive inspection that protects both your investment and peace of mind.",
//     img: img3
//   },
//   {
//     id: 4,
//     title: "LOYALTY",
//     description: "Choose us for our unwavering loyalty to you, the customer. Unlike many other platforms, we have no ties to any car dealerships, ensuring that our inspections are completely unbiased and focused solely on your best interests. Our commitment is to provide honest, transparent assessments, free from any external influence, so you can make decisions with full confidence and peace of mind. Trust us to put your needs first, every time.",
//     img: img4
//   },
// ];

const Cards = ({ featureCards }) => {
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <section className="flex items-center justify-center bg-banner overflow-hidden pb-5 pt-5">
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10">
        {Array.isArray(featureCards) &&
          featureCards.map((card, index) => (
            <li
              key={card.id}
              className="min-h-[450px] max-w-[350px] border-[3px] border-none rounded-2xl flex flex-col cursor-pointer transform transition-transform duration-300 ease-in-out hover:scale-110 hover:z-10"
              style={{
                boxShadow: '0 0 13px 0 #ADD143',
              }}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              {/* Image Section */}
              <div className="h-48">
                <img
                  src={card.image?.url}
                  alt={`image of card ${card.id}`}
                  className="w-full h-full object-cover rounded-t-2xl"
                />
              </div>

              {/* Content Section */}
              <div
                className="group flex flex-col justify-between rounded-b-2xl py-6 flex-grow transition-all duration-300 ease-in-out"
                style={{
                  backgroundColor: '#1F1F1F',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background =
                    'linear-gradient(to bottom, rgba(31, 31, 31, 1) 0%, rgba(51, 57, 31, 1) 100%)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = '#1F1F1F')
                }
              >
                <h1 className="text-[#C4C4C4] text-[21px] font-bold text-center transition-colors duration-300 ease-in-out group-hover:text-[#F0FFC5]">
                  {card.title}
                </h1>
                <p className="px-8 text-[#707070] text-[14px] text-center flex-grow transition-colors duration-300 ease-in-out group-hover:text-[#F0FFC5]">
                  {card.description}
                </p>
              </div>
            </li>
          ))}
      </ul>
    </section>
  );
};

export default Cards;